import React, {Component, ReactNode, ComponentType} from "react"
import {Row, Col, Grid} from "react-bootstrap"
import {match as Match, Redirect, withRouter} from "react-router-dom"

import {connect} from "@irati/store"
import {ReduxState} from "@irati/store/types"

import {MenuLinkLeft} from "./SideBar"

import StyledCol from "./styled/StyledCol"
import mainTheme from "@irati/ui/src/global/theme"

interface Props {
  indexRedirect: string,
  MobileMenu: string,
  mobileBack?: string,
  mobileBackLink?: string,
  Menu: ComponentType,
  match: Match,
  isMobile: boolean,
  location: Location,
  children: ReactNode,
  useGrid: boolean,
  usesNewSideNav: boolean // todo: remove this prop when all comps using this menu have been updated
}

const Div = (props: Props) => <div {...props} />

class AccountWrapper extends Component<Props> {
  static defaultProps: Pick<Props, "mobileBack" | "mobileBackLink" | "useGrid" | "usesNewSideNav"> = {
    mobileBack: "Back home",
    mobileBackLink: "/account",
    useGrid: true,
    usesNewSideNav: false
  }

  render() {
    const {
      useGrid,
      isMobile,
      match,
      location,
      indexRedirect,
      children,
      MobileMenu,
      mobileBack,
      mobileBackLink,
      Menu,
      usesNewSideNav
    } = this.props

    if (match.url === location.pathname) {
      if (!isMobile) {
        const to = {
          ...location,
          pathname: `${match.url}${indexRedirect}`
        }
        return <Redirect to={to} />
      }

      return <MobileMenu />
    }

    const Wrapper = useGrid ? Grid : Div

    return (
      <Wrapper style={{marginTop: isMobile ? mainTheme.spacing.one : mainTheme.spacing.six}}>
        <Row>
          <Col xsHidden sm={usesNewSideNav ? 4 : 3}>
            <Menu />
          </Col>
          <StyledCol xs={12} smHidden mdHidden lgHidden>
            <MenuLinkLeft to={mobileBackLink!}>{mobileBack}</MenuLinkLeft>
          </StyledCol>
          <StyledCol xs={12} sm={usesNewSideNav ? 8 : 9}>
            {children}
          </StyledCol>
        </Row>
      </Wrapper>
    )
  }
}

const mapStateToProps = ({mq}: ReduxState) => {
  return {
    isMobile: mq.lessThan.medium
  }
}

export default withRouter(connect(mapStateToProps)(AccountWrapper))
